import { Form, Row, Col, Button } from "react-bootstrap";
import { forwardRef, useState } from "react";
import AnalyzerFuncs, { EmailBody } from "./analyzer";
import { useAppSelector } from "../../redux/hooks";
import { lddStateObject, setActivityCenterAddNew } from "../../redux/reducer";
import { useDispatch } from "react-redux";
import { activityCenterObject } from "../../fileToolbar/ActivityCenter/activityCenterTypes";
import { formatAMPMString } from "../../fileToolbar/fileToolbarFuncs";
import { RPWDataReader, getDataReader } from "../../livedataFuncs";
import { StepsEnum } from "./DocsDropbox";
import { displayToastMsg } from "../toastMessages/toastmessages";

type IProps = {
    docID: string;
    fromStep: StepsEnum;
    setValidFeedback: (valid: boolean) => void;
    setStep: (step: StepsEnum) => void;
    feedbackType?: string;
}

const ContactHelp = forwardRef<HTMLButtonElement, IProps>((props: IProps, ContactRef) => {
    const livedataRootContainer = useAppSelector((state: lddStateObject) => state.currentNavigation.livedataRootContainer);
    const SESSION_INFO = useAppSelector((state: lddStateObject) => state.SessionInfo);
    const dispatch = useDispatch();
    const issues = [
        "Incorrect information",
        "Information was missing",
        "Require more information to be imported",
        "Other"
    ];

    // states
    const [reportIssues, setReportIssues] = useState([]);
    const [feedback, setFeedback] = useState("");

    // handlers
    const isChecked = (issue: string) => {
        return reportIssues && reportIssues.includes(issue);
    }

    const checkboxHandler = (checked: boolean, issue: string) => {
        props.setValidFeedback(true);
        if (checked) {
            setReportIssues([...reportIssues, issue]);
        } else {
            const index = reportIssues.findIndex(e => e === issue);
            reportIssues.splice(index, 1);
            setReportIssues([...reportIssues]);
            if (reportIssues.length === 0 && feedback === "") {
                props.setValidFeedback(false);
            }
        }
    }

    const feedbackChangeHandler = (e) => {
        props.setValidFeedback(true);
        setFeedback(e.target.value);
        if (reportIssues.length === 0 && e.target.value === "") {
            props.setValidFeedback(false);
        }
    }

    const submitHandler = (e) => {
        e.preventDefault();
        e.stopPropagation();
        try {
            let AppID: string;
            let DataReaderObj: RPWDataReader;
            if (livedataRootContainer.dataRoot) {
                DataReaderObj = getDataReader(livedataRootContainer.dataRoot);
                AppID = DataReaderObj.getAppId();
            }
            const { appCode, firm } = SESSION_INFO;
            const stationID = SESSION_INFO.user?.account;
            const emailData: EmailBody = {
                to: "tomas@ldd.ca",
                subject: props.feedbackType && props.feedbackType === "aps" ? "RenAI APS Client Feedback" : "Lender AI Request",
                msg: {
                    docID: props.docID,
                    path: `${appCode}/${firm.id}/${AppID}`,
                    issues: reportIssues,
                    feedback: feedback,
                    stationID: stationID
                }
            };
            AnalyzerFuncs.sendEmail(emailData, SESSION_INFO, emailCallback);
            props.setStep(StepsEnum.SendingEmail);
        } catch (err) {  }
    }

    const emailCallback = () => {
        let currentDate = new Date();
        let dateStr = currentDate.toDateString().split(" ");
        let timeStr = currentDate.toTimeString();
        timeStr = formatAMPMString(timeStr);
        const newMessage: activityCenterObject = {
            index: undefined,
            message: "Sent! Thank you. Your feedback is greatly appreciated.",
            type: "success",
            dateCreated: timeStr + ' ' + dateStr[1] + ' ' + dateStr[2] + ' ',
            clearWhenOut: true,
        };
        displayToastMsg({ id: null, msg: newMessage.message, type: newMessage.type }, null);
        dispatch(setActivityCenterAddNew(newMessage));
        props.setStep(props.fromStep);
    }

    return (
        <Form onSubmit={submitHandler}>
            <Row>
                <Col>
                    <h3>Which of the following best desribes the error you encountered?</h3>
                    {issues.map(issue =>
                        <Row key={issue}>
                            <Col>
                                <Form.Check
                                    name={issue}
                                    checked={isChecked(issue)}
                                    onChange={(e) => checkboxHandler(e.target.checked, issue)}
                                    label={issue}
                                />
                            </Col>
                        </Row>
                    )}
                    <br />
                    <h3>Describe your error in the textbox below.</h3>
                    <Form.Control as="textarea" rows={20} onChange={feedbackChangeHandler}></Form.Control>
                </Col>
            </Row>
            <Button type="submit" ref={ContactRef} style={{ display: "none" }}></Button>
        </Form>
    )
})

export default ContactHelp;